import axios from "axios";
import { encryptData, decryptData } from "../utils/encryption";

const TRANS_URL = process.env.REACT_APP_TRANSACTION_API_URL;

export async function getMaintainBidByUser(userEmail) {
    const encryptedEmail = encryptData(userEmail);
    const response = await axios
        .post(TRANS_URL + "/maintainbid/getmaintainbidbyuser", { CustomerEmail: encryptedEmail })
        .then(function (resp) { return resp; })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: [] };
        });
    return response.data;
}

export const placeBidUpdate = async (bidData) => {
    let url = `${TRANS_URL}/maintainbid/placebid`;

    // Encrypt sensitive data before sending
    const encryptedData = { ...bidData };
    if (encryptedData.CustomerEmail) {
        encryptedData.CustomerEmail = encryptData(encryptedData.CustomerEmail);
    }
    if (encryptedData.BidAmount) {
        encryptedData.BidAmount = encryptData(encryptedData.BidAmount.toString());
    }
    if (encryptedData.Remarks) {
        encryptedData.Remarks = encryptData(encryptedData.Remarks);
    }

    const response = await axios
        .post(url, encryptedData)
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: { message: "Unable to place bid", status: false } };
        });
    return response.data;
};

export async function getFrozenEnquiries() {
    const response = await axios
        .get(TRANS_URL + "/maintainbid/getfrozenenquiries")
        .then(function (resp) { return resp; })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: [] };
        });
    return response.data;
}

export async function updateSalesOrder(salesOrderData) {
    const response = await axios
        .post(TRANS_URL + "/maintainbid/updatesalesorder", salesOrderData)
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: { success: false, message: "Unable to update sales order" } };
        });
    return response.data;
}

export async function getUserFrozenBids(customerEmail, filters = {}) {
    const hasFilters = Object.values(filters).some(v => (Array.isArray(v) ? v.length > 0 : v !== ''));
    const url = hasFilters
        ? TRANS_URL + "/maintainbid/getfilteredfrozenbids"
        : TRANS_URL + "/maintainbid/getuserfrozenbids";
    const response = await axios
        .post(url, { CustomerEmail: customerEmail, ...filters })
        .then(function (resp) { return resp; })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: [] };
        });
    return response.data;
}

export async function getUpdateSalesOrderHistory(enquiryNumber, customerEmail) {
    const response = await axios
        .post(TRANS_URL + "/maintainbid/getupdatesalesorderhistory", { 
            EnquiryNumber: enquiryNumber, 
            CustomerEmail: customerEmail 
        })
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: [] };
        });
    return response.data;
}